import { Link } from "react-router-dom";
import { Truck, Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from "lucide-react";
import { useSiteSettings } from "../../context/SiteSettingsContext";

export default function Footer() {
  const { settings } = useSiteSettings();

  return (
    <footer className="bg-foreground text-background">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              {settings.logo_url ? (
                <img src={settings.logo_url} alt="Logo" className="h-10 object-contain" />
              ) : (
                <>
                  <div className="bg-primary p-2">
                    <Truck className="h-6 w-6 text-primary-foreground" />
                  </div>
                  <span className="font-bold text-xl tracking-tight" style={{ fontFamily: 'Chivo, sans-serif' }}>
                    NOLEGGIO<span className="text-primary">FURGONI</span>.IT
                  </span>
                </>
              )}
            </Link>
            <p className="text-muted-foreground text-sm max-w-md">
              La piattaforma leader in Italia per il noleggio di furgoni. 
              Trova il veicolo perfetto per le tue esigenze di trasporto.
            </p>
            
            {/* Social Links */}
            {(settings.social_facebook || settings.social_instagram || settings.social_linkedin) && (
              <div className="flex gap-3 mt-4">
                {settings.social_facebook && (
                  <a href={settings.social_facebook} target="_blank" rel="noopener noreferrer" 
                     className="text-muted-foreground hover:text-primary transition-colors">
                    <Facebook className="h-5 w-5" />
                  </a>
                )}
                {settings.social_instagram && (
                  <a href={settings.social_instagram} target="_blank" rel="noopener noreferrer"
                     className="text-muted-foreground hover:text-primary transition-colors">
                    <Instagram className="h-5 w-5" />
                  </a>
                )}
                {settings.social_linkedin && (
                  <a href={settings.social_linkedin} target="_blank" rel="noopener noreferrer"
                     className="text-muted-foreground hover:text-primary transition-colors">
                    <Linkedin className="h-5 w-5" />
                  </a>
                )}
              </div>
            )}
          </div>

          {/* Links */}
          <div>
            <h4 className="font-bold uppercase tracking-wider text-sm mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Link Utili
            </h4>
            <nav className="flex flex-col gap-2">
              <Link to="/catalogo" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                Catalogo Veicoli
              </Link>
              <Link to="/register" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                Registra la tua Azienda
              </Link>
              <Link to="/login" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                Area Riservata
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold uppercase tracking-wider text-sm mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Contatti
            </h4>
            <div className="flex flex-col gap-3">
              {settings.footer_email && (
                <a href={`mailto:${settings.footer_email}`} className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors">
                  <Mail className="h-4 w-4" />
                  {settings.footer_email}
                </a>
              )}
              {settings.footer_phone && (
                <a href={`tel:${settings.footer_phone.replace(/\s/g, '')}`} className="flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-colors">
                  <Phone className="h-4 w-4" />
                  {settings.footer_phone}
                </a>
              )}
              {(settings.footer_address || settings.footer_city) && (
                <div className="flex items-start gap-2 text-sm text-muted-foreground">
                  <MapPin className="h-4 w-4 mt-0.5" />
                  <span>
                    {settings.footer_address && <>{settings.footer_address}<br /></>}
                    {settings.footer_city}
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-muted-foreground/20 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} NoleggioFurgoni.it. Tutti i diritti riservati.
          </p>
          <div className="flex gap-4">
            <Link to="#" className="text-xs text-muted-foreground hover:text-primary transition-colors uppercase tracking-wider">
              Privacy Policy
            </Link>
            <Link to="#" className="text-xs text-muted-foreground hover:text-primary transition-colors uppercase tracking-wider">
              Termini e Condizioni
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
